import auth from '@/auth/index'
let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    meta: {
      title: '平台账户管理',
      breadLevel: 0,
      icon: 'icon-account',
      auth: auth.system
    },
    children: [
      {
        path: '/user',
        name: 'user',
        component: resolve => require(['@/views/system/user/list'], resolve),
        meta: {
          title: '用户管理',
          breadLevel: 0,
          auth: auth.system.userManage
        }
      },
      {
        path: '/role',
        name: 'role',
        component: resolve => require(['@/views/system/role/list'], resolve),
        meta: {
          title: '角色管理',
          breadLevel: 0,
          auth: auth.system.roleManage
        }
      },
      {
        path: '/role/setting',
        name: 'roleSetting',
        component: resolve => require(['@/views/system/role/settingAuth'], resolve),
        meta: {
          title: '配置权限',
          breadLevel: 1
        }
      }
    ]
  }
]
export default routes
